import BasicModal from '@app/components/Modal/BasicModal';
import AccountInactiveActivationModal from '@app/containers/Modal/AccountInactiveActivationModal';
import AccountPasswordChangeRecommendationModal from '@app/containers/Modal/AccountPasswordChangeRecommendationModal';
import AccountSuspendedModal from '@app/containers/Modal/AccountSuspendedModal';
import AlertWithLinkModal from '@app/containers/Modal/AlertWithLinkModal';
import BulkRequestCancelModal from '@app/containers/Modal/BulkRequestCancelModal';
import BulkRequestCreateModal from '@app/containers/Modal/BulkRequestCreateModal';
import BulkRequestDeleteWarningModal from '@app/containers/Modal/BulkRequestDeleteWarningModal';
import BulkRequestExcelValidationErrorModal from '@app/containers/Modal/BulkRequestExcelValidationErrorModal';
import BulkRequestSendTestModal from '@app/containers/Modal/BulkRequestSendTestModal';
import BulkRequestSigningExpiryPeriodChangeModal from '@app/containers/Modal/BulkRequestSigningExpiryPeriodChangeModal';
import BulkRequestStartedAlert from '@app/containers/Modal/BulkRequestStartedAlert';
import BulkRequestTerminateWarningModal from '@app/containers/Modal/BulkRequestTerminateWarningModal';
import BulkRequestUpdateTitleModal from '@app/containers/Modal/BulkRequestUpdateTitleModal';
import CancelSigningModal from '@app/containers/Modal/CancelSigningModal';
import ConfirmModal from '@app/containers/Modal/ConfirmModal';
import ContractLinkStartConfirmModal from '@app/containers/Modal/ContractLinkStartConfirmModal';
import ContractProgressConfirmWithInformationLinkModal from '@app/containers/Modal/ContractProgressConfirmWithInformationLinkModal';
import ContractSetupStartConfirmModal from '@app/containers/Modal/ContractSetupStartConfirmModal';
import CustomEmailSettingLogoImageConstraintsAlertModal from '@app/containers/Modal/CustomEmailSettingLogoImageConstraintsAlertModal';
import CustomEmailSettingLogoImageUploadModal from '@app/containers/Modal/CustomEmailSettingLogoImageUploadModal';
import CustomEmailSettingModal from '@app/containers/Modal/CustomEmailSettingModal';
import CustomEmailSettingStyleResetConfirmModal from '@app/containers/Modal/CustomEmailSettingStyleResetConfirmModal';
import DepositTransactionsModal from '@app/containers/Modal/DepositTransactionsModal';
import DigitalCertificateGuideCheckErrorModal from '@app/containers/Modal/DigitalCertificateGuideCheckErrorModal';
import DocumentBlockModal from '@app/containers/Modal/DocumentBlockModal';
import DocumentPollingErrorAlertModal from '@app/containers/Modal/DocumentPollingErrorAlertModal';
import DocumentsDirectToContractModal from '@app/containers/Modal/DocumentsDirectToContractModal';
import DocumentTransmitModal from '@app/containers/Modal/DocumentTransmitModal';
import DocumentUnBlockModal from '@app/containers/Modal/DocumentUnBlockModal';
import EditorContractSetupPreviewModal from '@app/containers/Modal/EditorContractSetupPreviewModal';
import EditorExitToMyDocumentsModal from '@app/containers/Modal/EditorExitToMyDocumentsModal';
import EditorSingleCompleteModal from '@app/containers/Modal/EditorSingleCompleteModal';
import ExitToEditingDocumentsModal from '@app/containers/Modal/ExitToEditingDocumentsModal';
import FileOpenPasswordPrecautionsModal from '@app/containers/Modal/FileOpenPasswordPrecautionsModal';
import FileUploadErrorModal from '@app/containers/Modal/FileUploadErrorModal';
import InvalidPhoneNumberModal from '@app/containers/Modal/InvalidPhoneNumberModal';
import LoginFailureBlockModal from '@app/containers/Modal/LoginFailureBlockModal';
import LoginFailureModal from '@app/containers/Modal/LoginFailureModal';
import NaverLoginReAgreeModal from '@app/containers/Modal/NaverLoginReAgreeModal';
import PageExitPreventionModal from '@app/containers/Modal/PageExitPreventionModal';
import ParticipantProcessingFailedModal from '@app/containers/Modal/ParticipantProcessingFailedModal';
import ParticipantProcessingModal from '@app/containers/Modal/ParticipantProcessingModal';
import RejectDocumentModal from '@app/containers/Modal/RejectDocumentModal';
import SendingToMailModal from '@app/containers/Modal/SendingToMailModal';
import SignatureProgressInformationModal from '@app/containers/Modal/SignatureProgressInformationModal';
import SigningProgressRejectionModal from '@app/containers/Modal/SigningProgressRejectionModal';
import SigningRequestAttachmentModal from '@app/containers/Modal/SigningRequestAttachmentModal';
import SingleSignatureTextFieldCheckModalContainer from '@app/containers/Modal/SingleSignatureTextFieldCheckModalContainer';
import TrialStartModal from '@app/containers/Modal/TrialStartModal';
import WelcomeChoiceModal from '@app/containers/Modal/WelcomeChoiceModal';
import WelcomeSurveyModal from '@app/containers/Modal/WelcomeSurveyModal';
import * as MODALS from '@app/store/modal/modalTypes';

const MODAL_COMPONENTS = {
  [MODALS.ACCOUNT_INACTIVE_ACTIVATION_MODAL]: AccountInactiveActivationModal,
  [MODALS.ACCOUNT_PASSWORD_CHANGE_RECOMMENDATION_MODAL]: AccountPasswordChangeRecommendationModal,
  [MODALS.ALERT_WITH_LINK_MODAL]: AlertWithLinkModal,
  [MODALS.BASIC_MODAL]: BasicModal,
  [MODALS.BULK_REQUEST_CANCEL_MODAL]: BulkRequestCancelModal,
  [MODALS.BULK_REQUEST_CREATE_MODAL]: BulkRequestCreateModal,
  [MODALS.BULK_REQUEST_DELETE_WARNING_MODAL]: BulkRequestDeleteWarningModal,
  [MODALS.BULK_REQUEST_EXCEL_VALIDATION_ERROR_MODAL]: BulkRequestExcelValidationErrorModal,
  [MODALS.BULK_REQUEST_SEND_TEST_MODAL]: BulkRequestSendTestModal,
  [MODALS.BULK_REQUEST_SIGNING_EXPIRY_CHANGE_MODAL]: BulkRequestSigningExpiryPeriodChangeModal,
  [MODALS.BULK_REQUEST_STARTED_ALERT]: BulkRequestStartedAlert,
  [MODALS.BULK_REQUEST_TERMINATE_WARNING_MODAL]: BulkRequestTerminateWarningModal,
  [MODALS.BULK_REQUEST_UPDATE_TITLE_MODAL]: BulkRequestUpdateTitleModal,
  [MODALS.CONFIRM]: ConfirmModal,
  [MODALS.CONTRACT_LINK_START_CONFIRM_MODAL]: ContractLinkStartConfirmModal,
  [MODALS.CONTRACT_PROGRESS_CONFIRM_WITH_INFORMATION_LINK_MODAL]:
    ContractProgressConfirmWithInformationLinkModal,
  [MODALS.CONTRACT_SETUP_START_CONFIRM_MODAL]: ContractSetupStartConfirmModal,
  [MODALS.CUSTOM_EMAIL_SETTING_MODAL]: CustomEmailSettingModal,
  [MODALS.CUSTOM_EMAIL_SETTING_LOGO_UPLOAD_MODAL]: CustomEmailSettingLogoImageUploadModal,
  [MODALS.CUSTOM_EMAIL_SETTING_LOGO_IMAGE_CONSTRAINTS_ALERT_MODAL]:
    CustomEmailSettingLogoImageConstraintsAlertModal,
  [MODALS.CUSTOM_EMAIL_SETTING_STYLE_RESET_CONFIRM_MODAL]: CustomEmailSettingStyleResetConfirmModal,
  [MODALS.DEPOSIT_TRANSACTIONS_MODAL]: DepositTransactionsModal,
  [MODALS.DIGITAL_CERTIFICATE_GUIDE_CHECK_ERROR_MODAL]: DigitalCertificateGuideCheckErrorModal,
  [MODALS.DOCUMENT_BLOCK_MODAL]: DocumentBlockModal,
  [MODALS.DOCUMENT_CANCEL_ALREADY_SIGNED_SIGNATURE_MODAL]: CancelSigningModal,
  [MODALS.DOCUMENT_POLLING_ERROR_ALERT_MODAL]: DocumentPollingErrorAlertModal,
  [MODALS.DOCUMENT_REJECT_CONTRACT_MODAL]: RejectDocumentModal,
  [MODALS.DOCUMENT_TRANSMIT_MODAL]: DocumentTransmitModal,
  [MODALS.DOCUMENT_UNBLOCK_MODAL]: DocumentUnBlockModal,
  [MODALS.DOCUMENTS_DIRECT_TO_CONTRACT_MODAL]: DocumentsDirectToContractModal,
  [MODALS.EDITOR_CONTRACT_SETUP_PREVIEW_MODAL]: EditorContractSetupPreviewModal,
  [MODALS.EDITOR_EXIT_TO_MY_DOCUMENTS_MODAL]: EditorExitToMyDocumentsModal,
  [MODALS.EDITOR_SINGLE_COMPLETE_MODAL]: EditorSingleCompleteModal,
  [MODALS.EXIT_TO_EDITING_DOCUMENTS_MODAL]: ExitToEditingDocumentsModal,
  [MODALS.FILE_UPLOAD_ERROR_MODAL]: FileUploadErrorModal,
  [MODALS.FILE_OPEN_PASSWORD_PRECAUTIONS_MODAL]: FileOpenPasswordPrecautionsModal,
  [MODALS.INVALID_PHONE_NUMBER_MODAL]: InvalidPhoneNumberModal,
  [MODALS.LOGIN_FAILURE_BLOCK_MODAL]: LoginFailureBlockModal,
  [MODALS.LOGIN_FAILURE_MODAL]: LoginFailureModal,
  [MODALS.NAVER_LOGIN_RE_AGREE_MODAL]: NaverLoginReAgreeModal,
  [MODALS.PAGE_EXIT_PREVENTION_MODAL]: PageExitPreventionModal,
  [MODALS.PARTICIPANT_PROCESSING_FAILED_MODAL]: ParticipantProcessingFailedModal,
  [MODALS.PARTICIPANT_PROCESSING_MODAL]: ParticipantProcessingModal,
  [MODALS.SENDING_TO_MAIL_MODAL]: SendingToMailModal,
  [MODALS.SIGNATURE_PROGRESS_INFORMATION_MODAL]: SignatureProgressInformationModal,
  [MODALS.SIGNING_PROGRESS_REJECTION_MODAL]: SigningProgressRejectionModal,
  [MODALS.SIGNING_REQUEST_ATTACHMENT_MODAL]: SigningRequestAttachmentModal,
  [MODALS.SINGLE_SIGNATURE_TEXT_FIELD_CHECK_MODAL]: SingleSignatureTextFieldCheckModalContainer,
  [MODALS.TRIAL_START_MODAL]: TrialStartModal,
  [MODALS.WELCOME_SURVEY_MODAL]: WelcomeSurveyModal,
  [MODALS.WELCOME_CHOICE_MODAL]: WelcomeChoiceModal,
  [MODALS.ACCOUNT_SUSPENDED_MODAL]: AccountSuspendedModal,
};

export default MODAL_COMPONENTS;
